import { apiWithResponseHandle } from 'models/LoadingUtil';
import {
  getAdminRemarkTemplates,
  getAdminTipConfig,
  updateAdminTipConfig,
} from 'services/AdminApiHelper';
import { getCountryCodes } from 'services/CountryCodeApiHelper';

const parseCountryCode = (item) => {
  return {
    id: item.id,
    pk: item.pk,
    name: `+${item.name}`,
    value: item.pk,
  };
};

const parseCountryCodeList = (data) => {
  return data.map((item) => {
    return parseCountryCode(item.node);
  });
};

const getInitialState = () => ({
  countryCodes: [],
  adminTipConfig: {},
  remarkTemplates: [],
});

export default {
  namespace: 'settings',
  state: getInitialState(),

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },

    clearData(state, { payload }) {
      return { ...state, ...getInitialState() };
    },
  },

  effects: {
    getCountryCodeList: [
      function* ({ payload }, { call, select, put }) {
        const serviceArgs = [getCountryCodes];
        function* onSuccess(data) {
          yield put({
            type: 'updateState',
            payload: {
              countryCodes: parseCountryCodeList(data?.countryCodes?.edges),
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    getAdminTipConfig: [
      function* ({ payload }, { call, select, put }) {
        const serviceArgs = [getAdminTipConfig];
        function* onSuccess(data) {
          const { adminTipConfig } = data;
          yield console.log('getAdminTipConfig', adminTipConfig);
          yield put({
            type: 'updateState',
            payload: {
              adminTipConfig,
            },
          });
        }
        function* onFailure(data) {
          yield put({
            type: 'updateState',
            payload: {
              adminTipConfig: {},
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess, onFailure);
      },
      { type: 'takeLatest' },
    ],

    updateAdminTipConfig: [
      function* ({ payload }, { call, select, put }) {
        const { data } = payload;
        const serviceArgs = [updateAdminTipConfig, data];
        function* onSuccess(data) {
          const { updateAdminTipConfig } = data;
          const { success, node: adminTipConfig } = updateAdminTipConfig;
          yield console.log('updateAdminTipConfig', success, adminTipConfig);
          yield put({
            type: 'updateState',
            payload: {
              adminTipConfig,
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],

    getAllRemarkTemplates: [
      function* ({ payload }, { call, select, put }) {
        const serviceArgs = [getAdminRemarkTemplates];
        function* onSuccess(data) {
          const { adminRemarkTemplates } = data;
          const remarkTemplates =
            adminRemarkTemplates?.edges
              ?.map((edge) => edge?.node)
              ?.filter((node) => !!node)
              ?.map((node) => ({
                id: node.pk,
                name: node.optionName,
              })) ?? [];
          console.log('remarkTemplates', remarkTemplates);
          yield put({
            type: 'updateState',
            payload: {
              remarkTemplates,
            },
          });
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
};
